<template>
 <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex left xs12 sm8 md8 text-xs-center>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Project Members</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form v-if="members.length < 15">
                  <!-- <v-alert v-if="user.data.city_accommodation && !user.data.accommodated" :value="true" type="info">
                    Remember, you have {{ accommodationItem.free_quantity }} free accommodation
                  </v-alert> -->
                  
                  <v-container grid-list-xl>
                    <v-layout>
                      <v-flex xs12 sm6 md6 text-xs-center>
                        <v-text-field clearable v-model="name_en" :counter="50" label="Full Name" :error-messages="errors.collect('name_en')" v-validate="{required: true, min: 10, max: 50, regex: /^\s?\w+(?:\s+\w+\s?){2,4}$/}" data-vv-name="name_en" data-vv-as="name in English" required append-icon="fa fa-user-circle" color="black">
                        </v-text-field>

                        <v-text-field clearable v-model="name_ar" :counter="50" label="الاسم ثلاثي" :error-messages="errors.collect('name_ar')" v-validate="{required: true, min: 10, max: 50, regex: /^\s?[\u0621-\u064A0-9]+(?:\s+[\u0621-\u064A0-9]+\s?){2,4}$/}" data-vv-name="name_ar" data-vv-as="name in Arabic" required append-icon="fa fa-user-circle" color="black">
                        </v-text-field>
                        
                        <v-text-field clearable v-model="email" :counter="50" label="E-mail Address" :error-messages="errors.collect('email')" v-validate="'required|email|max:50'" data-vv-name="email" append-icon="fa fa-at" required color="black">
                        </v-text-field>

                        <v-text-field clearable v-model="phone" append-icon="fa fa-phone" :counter="11" label="Phone Number" :error-messages="errors.collect('phone')" v-validate="'required|digits:11'" data-vv-name="phone" required color="black">
                        </v-text-field>

                        <v-select clearable :items="genders" v-model="gender" label="Gender" append-icon="fa fa-male" :error-messages="errors.collect('gender')" v-validate="'required|in:male,female'" data-vv-name="gender" item-text="text"  item-value="value" required color="black">
                        </v-select>

                        <v-switch label="Contact Person?" :true-value="true" :false-value="false" v-model="is_contact" v-if="!contacted">
                        </v-switch> 
                      </v-flex>
                    
                      <v-flex xs12 sm6 md6 text-xs-center>
                        <v-text-field clearable v-model="national_id" append-icon="fa fa-id-card" :counter="14" label="National ID" :error-messages="errors.collect('national_id')" v-validate="'required|digits:14'" data-vv-name="national_id" data-vv-as="National ID" required color="black">
                        </v-text-field>

                        <v-select required clearable :items="cities"  v-model="city_id" item-text="name_en" label="City" color="black" append-icon="fa fa-arrow-down" autocomplete item-value="id" v-validate="'required'">  
                        </v-select>

                        <v-text-field clearable v-model="cv_link" :counter="250" label="CV link (in pdf format)" :error-messages="errors.collect('cv_link')" v-validate="'required|max:250'" data-vv-name="cv_link" data-vv-as="CV link (in pdf format)" append-icon="fa fa-file" required color="black">
                        </v-text-field>

                        <v-text-field multi-line clearable v-model="technical_interests" :counter="250" label="Technical areas of interest" :error-messages="errors.collect('technical_interests')" v-validate="'required|min:10|max:250'" data-vv-name="technical_interests" data-vv-as="Technical areas of interest" append-icon="fa fa-brain" required color="black">
                        </v-text-field>

                        <!-- <v-switch v-if="user.data.city_accommodation" label="Need accommodation?" v-model="accommodation" :true-value="true" :false-value="false">
                        </v-switch> -->
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-alert v-if="editMode" :value="true" type="info">
                    Your IDs have been saved already. No need to upload them again unless you wish to change them.
                  </v-alert>

                  <v-container grid-list-xl v-if="clearVar">
                    <v-layout>
                      <v-flex xs12 sm6 md6>
                        <div class="upload_images">
                          <p>Upload National ID Front</p>
                          <vue-base64-file-upload placeholder="Upload National ID Front" class="v1" accept="image/png,image/jpeg" image-class="v1-image" input-class="v1-image" :max-size="customImageMaxSize" @load="loadFront" @size-exceeded="onSizeExceeded"/>
                        </div>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <div class="upload_images">
                          <p>Upload National ID Back</p>
                          <vue-base64-file-upload placeholder="Upload National ID Back" class="v2" accept="image/png,image/jpeg" image-class="v2-image" input-class="v2-image" :max-size="customImageMaxSize" @load="loadBack" @size-exceeded="onSizeExceeded"/>
                        </div>
                      </v-flex>
                      <!-- <v-flex xs12 sm6 md6>
                        <div v-model="id_front" class="upload_images">
                          <p>Upload National ID front</p>
                          <input type="file" @change="loadFront" accept="image/png,image/jpeg" ref="fileInputFront" required />
                        </div>
                      </v-flex> -->
                    
                      <!-- <v-flex xs12 sm6 md6>
                        <div :v-model="id_back" class="upload_images">
                          <p>Upload National ID back</p>
                          <input type="file" @change="loadBack" accept="image/png,image/jpeg" ref="fileInputBack" required />
                        </div>
                      </v-flex> -->
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" left @click.prevent="rollBack"  :disabled="editMode">Previous</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="editMode" @click.prevent="cancelEdit" color="error">Cancel</v-btn>
                <v-btn v-if="editMode" @click.prevent="addMember" :disabled="!! (errors.any() || !isDisabled)" default>Save Member</v-btn>
                <v-btn v-else @click.prevent="addMember" :disabled="!! (errors.any() || !isDisabled)" default>Add Member</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" right @click.prevent="proceed" :disabled="editMode">Next</v-btn>
              </v-card-actions>
              <v-list two-line subheader>
                <v-subheader inset>
                  Members
                  <v-spacer></v-spacer>
                  <v-icon>fa fa-users</v-icon>
                </v-subheader>
                <v-list-tile avatar v-for="(member,index) in members" :key="member.name">
                  <v-list-tile-avatar>
                    <v-icon> fa fa-{{ member.gender }}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ member.name_en }} &mdash; {{member.name_ar}}</v-list-tile-title>
                    <v-list-tile-sub-title>
                      <v-icon>email</v-icon> {{member.email}} &mdash; 
                      <v-icon>phone</v-icon>{{member.phone}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon ripple  @click.prevent="editMember(index)">
                      <v-icon color="grey lighten-1">fa fa-edit</v-icon>
                    </v-btn>

                    <button icon ripple v-confirm="{
                      loader: true,
                      ok: dialog => removeMember(dialog, index),
                      cancel: doNothing,
                      message: 'Are you sure you want to remove this member?'}">
                      <v-icon color="grey lighten-1">fa fa-trash</v-icon>
                    </button>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider inset></v-divider>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
  import VueBase64FileUpload from 'vue-base64-file-upload';
  export default {
    props: ['user','items','cities'],
    components: {
      VueBase64FileUpload
    },
    data(){
      return {
        genders: [{text: 'Male' , value:'male'} , {text: 'Female' , value: 'female'}],
        email: '',
        phone: '',
        name_en: '',
        name_ar: '',
        contacted: false,
        accommodation: false,
        is_contact: false,
        gender: '',
        city_id: '',
        national_id: '',
        cv_link: '',
        technical_interests: '',
        id_front: '',
        id_back: '',
        members: [],
        clearVar: true,
        editMode: false,
        editingMember: {},
        validExt: ['png', 'gif', 'jpg', 'jpeg'],
        customImageMaxSize: 2 // megabytes
      }
    },
    computed: {
      accommodationItem() {
        return this.items.find(item => item.name == 'Accommodation');
      },
      isDisabled() {
        return !! (this.phone && this.email && this.name_en && this.gender && this.technical_interests && this.national_id && this.city_id && this.cv_link);
      },

    },
    methods: {
      validBase64(decoded) {
        var lowerCase = decoded.toLowerCase();

        for (var i = 0; i < this.validExt.length; i++) {
          if (lowerCase.indexOf(this.validExt[i]) !== -1) {
            return true;
          }
        }
        return false;
      },
      addMember(){
        if (this.id_back && this.id_front) {
          if (this.validBase64(this.id_front) && this.validBase64(this.id_back)) {
            let membersWithAccommodations = this.members.filter(member => member.has_accommodation == true);
            if (membersWithAccommodations.length < this.accommodationItem.max_quantity ) {
             if (this.members.filter(member => (this.phone === member.phone || this.email === member.email)).length > 0) {
                this.$noty.error('Member Phone Number  & Email should be unique');
              } else {
                let phonePrefix = this.phone.substring(0, 3);
                if (phonePrefix === '011' || phonePrefix === '010' || phonePrefix === '012' || phonePrefix === '015' ) {
                  if (this.is_contact) {
                    this.contacted = true;
                  }
                  if (this.accommodation) {
                    this.user.data.accommodated = true;
                  }
                  this.members.push({
                    'phone': this.phone,
                    'email': this.email,
                    'name_en': this.name_en,
                    'is_contact': this.is_contact,
                    'has_accommodation': this.accommodation,
                    'gender': this.gender,
                    'name_ar': this.name_ar,
                    'id_front': this.id_front,
                    'id_back': this.id_back,
                    'national_id': this.national_id,
                    'city_id': this.city_id,
                    'cv_link': this.cv_link,
                    'technical_interests': this.technical_interests
                  });
                  this.resetForm();
                } else {
                  this.$noty.error('Unknown Phone Number Provider.');
                }
              }
            } else {
              this.$noty.error('Only ' + this.accommodationItem.max_quantity + ' members may have an accommodation');
            }
          } else {
            this.$noty.error("Only (" + this.validExt.join(', ') + ") extensions are allowed for IDs");
          }
        } else {
          this.$noty.error("You must upload member's national ID (front and back) image before adding");
        }
      },
      removeMemberDialog(dialog, index){
        this.removeMember(index)
        dialog.close()
      },
      removeMember(index){
        if (this.members[index].is_contact === true) {
          this.contacted = false;
        }
        this.members.splice(index, 1);
        if (this.members.filter(member => member.has_accommodation == true).length == 0) {
          this.user.data.accommodated = false;
        }
      },
      editMember(index) {
        let member = this.members[index];
        this.editMode = true;
        this.editingMember = JSON.parse(JSON.stringify(member));
        this.phone = member.phone;
        this.email = member.email;
        this.name_en = member.name_en;
        this.name_ar = member.name_ar;
        this.gender = member.gender;
        this.id_back = member.id_back;
        this.id_front = member.id_front;
        this.is_contact = member.is_contact;
        this.accommodation = member.has_accommodation;
        this.national_id = member.national_id;
        this.city_id = member.city_id;
        this.cv_link = member.cv_link;
        this.technical_interests = member.technical_interests;
        this.removeMember(index)
      },
      cancelEdit() {
        let member = this.editingMember;
        this.phone = member.phone;
        this.email = member.email;
        this.name_en = member.name_en;
        this.name_ar = member.name_ar;
        this.gender = member.gender;
        this.id_back = member.id_back;
        this.id_front = member.id_front;
        this.is_contact = member.is_contact;
        this.accommodation = member.has_accommodation;
        this.national_id = member.national_id;
        this.city_id = member.city_id;
        this.cv_link = member.cv_link;
        this.technical_interests = member.technical_interests;
        this.addMember();
      },
      doNothing() {
        // Do nothing or some other stuffs
      },
      onSizeExceeded(size) {
        alert(`Image size exceeds limits of ${this.customImageMaxSize}Mb!`);
      },
      loadFront(e) {
        this.id_front = e;
      },
      loadBack(e) {
        this.id_back = e;
      },
      // loadBack(e) {}
      //   const files = e.target.files || e.dataTransfer.files;

      //   if (!files.length) {
      //     alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`);
      //   }

      //   const file = files[0];
      //   const size = file.size && (file.size / Math.pow(1000, 2));

      //   // check file max size
      //   if (size > this.customImageMaxSize) {
      //     this.$emit('size-exceeded', size);
      //     return;
      //   }

      //   const reader = new FileReader();

      //   reader.onload = e => {
      //     const dataURI = e.target.result;
      //     this.id_back = dataURI;
      //   };

      //   reader.readAsDataURL(file);
      // },
      reset() {
        this.clearVar = false
        this.$nextTick(() => {
          this.clearVar = true
        })
      },
      resetForm() {
        this.phone = '';
        this.email = '';
        this.name_en = '';
        this.name_ar = '';
        this.id_back = '';
        this.id_front = '';
        this.gender = '';
        this.is_contact = false;
        this.accommodation = false;
        this.national_id = '';
        // this.city_id = '';
        this.cv_link = '';
        this.technical_interests = '';
        
        // const inputFront = this.$refs.fileInputFront
        // inputFront.type = 'text'
        // inputFront.type = 'file'
        // const inputBack = this.$refs.fileInputBack
        // inputBack.type = 'text'
        // inputBack.type = 'file'

        this.reset()

        this.$validator.reset();
        this.errors.clear();
        this.editMode = false;
      },
      rollBack(){
         this.$emit('rollback',this.user)
      },
      proceed(){
        if (this.members.length < 2) {
          this.$noty.error('You must add at least two members');
        } else if (!this.contacted) {
          this.$noty.error('You must add at least one member as contact person');
        } else {
          // if (this.user.data.city_accommodation) {
          //   let totalAccommodation = this.members.filter(member => member.has_accommodation == true);
          //   if (totalAccommodation.length) {
          //   this.$noty.success('Total Price Of Accommodation is ' + ((totalAccommodation.length - (this.user.data.city_accommodation * this.accommodationItem.free_quantity)) * this.accommodationItem.price) + ' L.E ');
          //   } else {
          //     this.$noty.success('Total Price Of Accommodation is 0 L.E');
          //   }
          // } else {
            for (var i = 0; i < this.members.length; i++) {
              this.members[i].has_accommodation = false;
            }
          // }
          this.user.data.members = this.members;
          this.$emit('completed',this.user);
        }
      }
    }

  };
</script>
<style scoped>
.contact {
  float: right;
  margin-right :750px;
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Registeration/Members.vue